// Helpers an adapter can reuse when turning an address into a word entry.
// Ported from toseftasite's resolveManuscriptEntry: HTR coverage is never
// complete, so a word with no box of its own falls back to the nearest word
// that does have one -- the reader still lands on the right line, and the
// panel flags the result as approximate rather than showing nothing.

// `maxDistance` caps how far the fallback may reach (in base-word positions).
// Unbounded -- as the original was -- a chapter with two recognised words
// happily points the reader at something a hundred words away and calls it
// approximate. Beyond the cap, return null so the panel says "not found"
// rather than showing a confidently wrong box.
export function nearestEntry(wordsByIdx, baseIdx, { maxDistance = Infinity } = {}) {
    if (!wordsByIdx) return null;
    const keys = Object.keys(wordsByIdx);
    if (!keys.length) return null;

    const exact = wordsByIdx[String(baseIdx)];
    if (exact) return { status: 'exact', entry: exact, distance: 0 };

    let nearestKey = null, nearestDist = Infinity;
    for (const k of keys) {
        const dist = Math.abs(Number(k) - baseIdx);
        if (dist < nearestDist) { nearestDist = dist; nearestKey = k; }
    }
    if (nearestKey == null || nearestDist > maxDistance) return null;
    return { status: 'approx', entry: wordsByIdx[nearestKey], distance: nearestDist };
}
